export default [
  {
    header: 'Финансы',
    resource: 'finance',
    action: 'view',
  },
  {
    title: 'Финансы',
    route: 'finance',
    icon: 'DollarSignIcon',
    resource: 'finance',
    action: 'view',
  },
]
